import React from 'react';

import { Badge, Button } from '@rbilabs/universal-components';
import { StyleSheet, View } from 'react-native';

import { primitive } from 'styles/constants';

import type { OfferListItemProps } from '../types';

type OfferHeaderProps = Pick<
  OfferListItemProps,
  'offerApplied' | 'offerText' | 'handleRemove' | 'removeOfferText'
>;

export const OfferHeader = ({
  offerApplied,
  offerText,
  handleRemove,
  removeOfferText,
}: OfferHeaderProps) => {
  const offerIsApplied = offerApplied && offerText && handleRemove && removeOfferText;

  if (!offerIsApplied) {
    return null;
  }

  return (
    <View style={styles.appliedHeader}>
      {!!offerText && (
        <Badge
          variant="default-subtle"
          iconName="checkFill"
          backgroundColor={primitive.$successLight}
        >
          {offerText}
        </Badge>
      )}
      <Button variant="ghost" onPress={handleRemove} size="md" testID="offer-remove">
        {removeOfferText}
      </Button>
    </View>
  );
};

const styles = StyleSheet.create({
  appliedHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: 8, // $2
    marginBottom: 8, // $2
  },
});
